import React, {useState} from "react";
import {Card, Col, Row, Spin} from "antd";
import {EditOutlined} from "@ant-design/icons";
import PropTypes from "prop-types";

import CarHardwareForm from "./CarHardwareForm";
import {userHasRole} from "../../lib/role";

import './CarHardware.less';

const CarHardwareCard = ({carID, hardwareType, hardwareExternalID, handleRefreshHardware, loading}) => {
    const isFleet = userHasRole('staff', 'developer') || userHasRole('staff', 'fleet');
    const [openDrawer, setOpenDrawer] = useState(false);

    const showDrawer = () => {
        setOpenDrawer(true);
    };

    const handleHideDrawer = () => {
        setOpenDrawer(false);
    };

    return (
        <Card title="Hardware Details"
              bordered={true}
              className="details-card"
              extra={
                  isFleet === true ? <EditOutlined key="edit" onClick={() => showDrawer()}/> : null
              }
        >
            <Spin spinning={loading}>
                <Row>
                    <Col xs={24} md={12}>
                        <strong>Hardware:</strong>
                    </Col>
                    <Col xs={24} md={12}>
                        <span className="long-text-wrap">{hardwareType}</span>
                    </Col>
                </Row>
                <Row>
                    <Col xs={24} md={12}>
                        <strong>Astus Vehicle ID:</strong>
                    </Col>
                    <Col xs={24} md={12}>
                        <span className="long-text-wrap">{hardwareExternalID !== 0 ? hardwareExternalID : 'N/A'}</span>
                    </Col>
                </Row>
                <CarHardwareForm
                    openDrawer={openDrawer}
                    hideDrawer={handleHideDrawer}
                    carID={carID}
                    handleRefreshHardware={handleRefreshHardware}
                    existingHardwareType={hardwareType}
                />
            </Spin>
        </Card>
    )
}

CarHardwareCard.propTypes = {
    carID: PropTypes.number.isRequired,
    hardwareType: PropTypes.string.isRequired,
    hardwareExternalID: PropTypes.number.isRequired,
    handleRefreshHardware: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
};

export default CarHardwareCard;
